import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import Career from "./careerObjective/careerObjective";

/**
 * parent Component for displaying both career objective details 
 */
class CareerObjective extends Component {
  render() {
    return (
      <Container
        style={{ maxWidth: "75%", marginTop: "40px !important" }}
        className="card container-card migrator-mt personalDetails-div-1 contact-res "
      >
        <i
          className="material-icons contact-cancel-button pointer"
          onClick={this.props.back}
        >
          cancel
        </i>
        <Row>
          <Col md="12" className=" profile-contact-details-col mx-auto">
            <Career />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default CareerObjective;
